// TOP LEVEL
export const APP_HOME_ROUTE = "/";
export const APP_CREATE_ROUTE = "/create";

// AUTH (mostly used for mobile)
export const APP_LOGIN_ROUTE = "/login";
export const APP_SIGNUP_ROUTE = "/signup";
export const APP_CHANGE_PASSWORD_ROUTE = "/change-password";
export const APP_RESET_PASSWORD_ROUTE = "/reset-password";

// PROFILE
export const APP_PROFILE_ROUTE = "/account";
export const APP_PROFILE_EDIT_ROUTE = `${APP_PROFILE_ROUTE}/edit`;

// INFO
export const APP_FAQ_ROUTE = "/faq";
export const APP_TERMS_ROUTE = "/terms";
export const APP_PRIVACY_ROUTE = "/privacy";
export const APP_GUIDELINES_ROUTE = "/guidelines";
